import { skipToken } from '@reduxjs/toolkit/query';
import { useGetServicingV1AccountsLenderAccountIdentifierBankAccountsQuery, } from 'servicing-api';
import { isActiveBankAccount } from '../utils';
/** Resolves the bank account with the given servicing id, as long as it can still be charged. */
function useSelectedBankAccount(lenderAccountIdentifier, bankAccountId) {
    const { data: bankAccounts } = useGetServicingV1AccountsLenderAccountIdentifierBankAccountsQuery(lenderAccountIdentifier && bankAccountId
        ? { lenderAccountIdentifier }
        : skipToken, { refetchOnMountOrArgChange: true });
    return bankAccounts?.find((account) => account.id === bankAccountId && isActiveBankAccount(account));
}
export default useSelectedBankAccount;
